export enum PrimerStatusEnum {
    ALL = -1,
    PENDING = 0,
    AVAILABLE,
    OUT_OF_STOCK,
    ARCHIVED,
    TUBE_MISSING,
    CONTAMINATED,
}

export enum InventoryPrimerStatusEnum {
    ALL = -1,
    PENDING = 0,
    NOT_RECEIVED,
    AVAILABLE,
    ARCHIVED,
    CONTAMINATED,
}
